import React, { useEffect } from 'react';
import { Modal } from '@carvana/showroom-modal';
import DuplicatePaymentIcon from '../../../assets/DuplicatePaymentIcon';
import {
  ModalContentWrapper,
  Description,
  DetailsRow,
  DetailHighlight,
  ConfirmButton,
  DetailsRowWithAmount,
} from './OneTimeDuplicatePaymentDialog.styles';
import { formatCurrency } from '../../../utils/CurrencyUtils';
import { useDualEventTracking } from '../../../utils/useDualEventTracking';

const OneTimeDuplicatePaymentDialog = ({
  modalData,
  openModal,
  toggleDuplicatePaymentModal,
  confirmDuplicatePayment,
}: any) => {
  const { withdrawalAmount, selectedDate } = modalData;

  const { trackEvent } = useDualEventTracking();

  useEffect(() => {
    if (openModal) {
      trackEvent('duplicate_payment_warning_dialogue');
    }
  }, [openModal]);

  const handleClick = () => {
    /**
     * Sending true to showDuplicateModal in order to prevent
     * duplicate pay modal from showing on a loop
     * */
    trackEvent('duplicate_payment_warning_confirm_button_tap');
    toggleDuplicatePaymentModal(true);
    confirmDuplicatePayment();
  };

  const closeModal = () => {
    trackEvent('duplicate_payment_warning_exit_tap');
    toggleDuplicatePaymentModal(false);
  };

  const headerText = 'Duplicate payment';

  return (
    <Modal
      headerText={headerText}
      mode="light"
      isOpen={openModal}
      closeModal={closeModal}
    >
      <ModalContentWrapper>
        <DuplicatePaymentIcon />
        <Description>
          Are you sure you want to schedule this duplicate payment to
          Bridgecrest?
        </Description>
        <DetailsRow>
          There is already a payment scheduled for{' '}
          <DetailHighlight>{selectedDate}.</DetailHighlight>
        </DetailsRow>
        <DetailsRowWithAmount>
          Continue with this payment for
          <DetailHighlight>{formatCurrency(withdrawalAmount)}?</DetailHighlight>
        </DetailsRowWithAmount>
        <ConfirmButton id="confirm-payment-btn" onClick={handleClick}>
          Confirm Payment
        </ConfirmButton>
      </ModalContentWrapper>
    </Modal>
  );
};

export default OneTimeDuplicatePaymentDialog;
